/* Mantelly spin wheel (29/09/2026). Config: #mt-spin-cfg; markup: #mt-spin-tpl (sections/mt-spin-wheel.liquid).
   Design: loja/fase2/roleta/DESENHO.md. No dependencies. Honest client-side draw (crypto), recorded before the animation. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('mt-spin-cfg');
  var tpl = document.getElementById('mt-spin-tpl');
  if (!cfgEl || !tpl || window.__mtSpin) return;
  window.__mtSpin = true;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!C || C.mode === 'disabled' || typeof HTMLDialogElement !== 'function') return;

  var root = document.documentElement;
  var DAY = 864e5;
  var K = { spin: 'mt_spin', clk: 'mt_spin_clk', dis: 'mt_spin_dis', sub: 'mt_spin_sub' };
  var SLICES = [10, 5, 15, 20, 10, 5, 15, 20];
  var EXCL = /^\/(cart\/?$|checkouts?(\/|$)|account|challenge|password|apps\/track123|pages\/track-order|pages\/gift-finder)/;
  var T = C.t || {};

  // ---------- storage (1 spin per visitor needs storage; without it, nothing shows) ----------
  var STORE = true;
  try { localStorage.setItem('mt_spin_t', '1'); localStorage.removeItem('mt_spin_t'); } catch (e) { STORE = false; }
  if (!STORE) return;
  function get(k) { try { var v = localStorage.getItem(k); return v === null ? null : JSON.parse(v); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function del(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }

  // ---------- preview-only test hooks ----------
  var q;
  try { q = new URLSearchParams(location.search); } catch (e) { q = { get: function () { return null; } }; }
  var th = window.Shopify && window.Shopify.theme;
  var PREVIEW = !!(th && th.role && th.role !== 'main') || !!(window.Shopify && window.Shopify.designMode);
  var LOOSE = C.mode === 'test', FAST = LOOSE, NOW = false, DRY = false, FAKE_CH = false;
  if (PREVIEW) {
    if (q.get('mt_spin_test') === '1') sset('mt_spin_test', '1');
    if (q.get('mt_spin_test') === '0') sset('mt_spin_test', null);
    if (sget('mt_spin_test') === '1') FAST = true;
    if (q.get('mt_spin') === 'reset') { [K.spin, K.clk, K.dis, K.sub].forEach(del); sset('mt_spin_applied', null); }
    NOW = q.get('mt_spin') === 'now';
    DRY = q.get('mt_spin_dry') === '1';
    FAKE_CH = q.get('mt_spin_challenge') === '1';
    var age = /^(\d+)d$/.exec(q.get('mt_spin_age') || '');
    if (age) { var s0 = get(K.spin); if (s0 && s0.t) { s0.t = Date.now() - (+age[1]) * DAY; set(K.spin, s0); } }
  }

  // ---------- state ----------
  function validSpin(s) { return s && s.v === 1 && s.c && s.p ? s : null; }
  var S = validSpin(get(K.spin));
  // write one change on top of what is stored now (another tab may have updated the same spin)
  function patchSpin(k, v) {
    var cur = validSpin(get(K.spin));
    if (cur && S && cur.t === S.t) { var r = S.r; S = cur; if (r) S.r = 1; }
    S[k] = v; set(K.spin, S);
  }
  var now0 = Date.now();
  var EXP = Math.max(1, +C.expiry || 7) * DAY;
  var excludedPage = EXCL.test(location.pathname);
  var posted = q.get('customer_posted') === 'true';

  // Subscriber signals: came from an email, footer signup, or the old WELCOME10 pop-up.
  if (q.get('utm_medium') === 'email') set(K.sub, 1);
  if (posted && !(S && S.s === 'pending')) set(K.sub, 1);
  try { if (localStorage.getItem('promo-bar-subscribed-' + location.host)) set(K.sub, 1); } catch (e) {}
  var cookieCode = /(?:^|;\s*)discount_code=/.test(document.cookie);

  function daysLeft(s) { return Math.max(0, Math.ceil((s.t + EXP - Date.now()) / DAY)); }
  function isExpired(s) { return Date.now() - s.t >= EXP; }

  var dis = +get(K.dis) || 0;
  var autoEligible = !S && !excludedPage &&
    (LOOSE || (!C.known && !get(K.sub) && !cookieCode && (now0 - dis) > Math.max(1, +C.dismiss || 3) * DAY));

  // ---------- tiny helpers ----------
  function track(name, data) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function vis(el) {
    if (!el) return false;
    var cs = getComputedStyle(el), r = el.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' && +cs.opacity !== 0 && r.height > 0 && r.width > 0;
  }
  var MONTHS = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  function fmtDate(ms) { var d = new Date(ms); return MONTHS[d.getMonth()] + '\u00a0' + d.getDate(); }
  function fill(str, s) {
    return String(str || '').replace(/\[code\]/g, s.c).replace(/\[pct\]/g, s.p)
      .replace(/\[days\] days/g, Math.round(EXP / DAY) + '\u00a0days').replace(/\[days\]/g, Math.round(EXP / DAY)).replace(/\[date\]/g, fmtDate(s.t + EXP));
  }
  function prizeFor(p) { for (var i = 0; i < C.prizes.length; i++) if (C.prizes[i].p === p) return C.prizes[i]; return null; }

  // ---------- CSS (lazy) ----------
  var cssState = 0, cssCbs = [];
  function loadCss(cb) {
    if (cb) cssCbs.push(cb);
    if (cssState === 2) { flushCss(); return; }
    if (cssState === 1) return;
    cssState = 1;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = C.css;
    l.onload = function () { cssState = 2; flushCss(); };
    l.onerror = function () { cssState = 0; };
    document.head.appendChild(l);
  }
  function flushCss() { var cbs = cssCbs; cssCbs = []; cbs.forEach(function (f) { f(); }); }

  // ---------- guards (same spirit as snippets/mt-popup-guard.liquid) ----------
  var lastAtc = 0, lastFocusOut = 0, freeSince = 0;
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="add"], [data-mt-atc], .quick-add__submit, button[type="submit"][form^="product-form"]');
    if (t) lastAtc = Date.now();
  }, true);
  document.addEventListener('focusout', function (e) { if (isField(e.target)) lastFocusOut = Date.now(); }, true);
  function isField(el) { return el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && !(dlg && dlg.contains(el)); }
  function drawerOpen() { return !!document.querySelector('cart-drawer.active, .drawer.active'); }
  function bannerOn() {
    return (root.classList.contains('ccd-ready') && vis(document.getElementById('shopify-pc__banner'))) ||
      vis(document.getElementById('shopify-pc__prefs'));
  }
  function ccdOn() { return vis(document.querySelector('.ccd')); }
  function otherModal() {
    var list = document.querySelectorAll('dialog[open], [aria-modal="true"]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (dlg && (el === dlg || dlg.contains(el))) continue;
      if (el.closest('#shopify-pc__banner') || el.closest('#shopify-pc__prefs')) continue;
      if (vis(el)) return true;
    }
    return false;
  }
  function blockReason() {
    if (excludedPage) return 'page';
    // compra direta (07/10): com uma compra a caminho do checkout (snippets/mt-direct-checkout.liquid), nada abre por cima
    if (window.mtDC && (window.mtDC.indo || window.mtDC.ocupado)) return 'checkout';
    if (drawerOpen()) return 'drawer';
    if (/(^|\s)overflow-hidden/.test(document.body.className)) return 'overlay';
    if (otherModal()) return 'modal';
    if (bannerOn()) return 'cookie-banner';
    if (ccdOn()) return 'cookie-notice';
    if (isField(document.activeElement) || Date.now() - lastFocusOut < 3000) return 'typing';
    if (Date.now() - lastAtc < 3000) return 'atc';
    return '';
  }

  // ---------- cookie-notice queue (US etc.): hold the own .ccd while the wheel can still open here ----------
  var holdTimer = 0;
  function hold(on) {
    clearTimeout(holdTimer);
    if (on) root.classList.add('mt-spin-hold-ccd');
    else holdTimer = setTimeout(function () { root.classList.remove('mt-spin-hold-ccd'); }, 1500);
  }
  if (autoEligible) root.classList.add('mt-spin-hold-ccd');

  // ---------- visible-time clock (across pages and tabs) ----------
  var lastTick = Date.now(), dueAt = 0;
  function clk() {
    var c = get(K.clk);
    if (!c || typeof c.acc !== 'number' || Date.now() - (c.last || 0) > 30 * 60e3) c = { acc: 0, last: Date.now() };
    return c;
  }
  function tick() {
    var t = Date.now(), d = Math.min(t - lastTick, 2000);
    lastTick = t;
    var c = clk();
    if (document.visibilityState === 'visible') c.acc += d / 1000;
    c.last = t;
    set(K.clk, c);
    return c.acc;
  }
  var DELAY = FAST ? (+C.delayTest || 8) : (+C.delay || 60);

  // ---------- dialog ----------
  var dlg = null, step = 'form', prevFocus = null, closingByDrawer = false, spinTimer = 0, rot = 0, openedAt = 0;
  function $(sel) { return dlg.querySelector(sel); }
  function build() {
    if (dlg) return dlg;
    var frag = tpl.content.cloneNode(true);
    dlg = frag.querySelector('dialog');
    document.body.appendChild(dlg);
    dlg.addEventListener('close', onClose);
    dlg.addEventListener('click', function (e) {
      // backdrop tap closes, but not in the first 700 ms (a tap meant for the page as the sheet slides in)
      if (e.target === dlg) { if (Date.now() - openedAt > 700) dlg.close(); return; }
      var t = e.target.closest('[data-mts-close]');
      if (t) { e.preventDefault(); dlg.close(); }
    });
    var form = $('form');
    // Enter / button: always ours (validation first); the captcha stack only runs through form.submit() in post()
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); onSpin(); });
    form.submit = function () { sendFetch(form); };
    var inp = $('#MtSpinEmail');
    inp.addEventListener('focus', function () { dlg.classList.add('is-typing'); });
    inp.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== inp) dlg.classList.remove('is-typing'); }, 120); });
    inp.addEventListener('input', function () { showErr(''); });
    var cb = $('[data-mts-consent]');
    if (cb) cb.addEventListener('change', function () { showErr(''); });
    var hub = $('[data-mts-hub]');
    hub.addEventListener('click', function () { if (step === 'form') { if (!inp.value.trim()) inp.focus(); else onSpin(); } });
    var ob = $('[data-mts-odds]');
    if (ob) ob.addEventListener('click', function () {
      var o = $('#MtsOdds'), open = o.hidden;
      o.hidden = !open; ob.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $('[data-mts-copy]').addEventListener('click', onCopy);
    $('[data-mts-apply]').addEventListener('click', onApply);
    if (window.visualViewport) {
      var vv = window.visualViewport;
      var onVV = function () {
        if (!dlg || !dlg.open) return;
        var kb = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
        dlg.style.setProperty('--mts-kb', Math.round(kb) + 'px');
        dlg.style.setProperty('--mts-vvh', Math.round(vv.height) + 'px');
      };
      vv.addEventListener('resize', onVV);
      vv.addEventListener('scroll', onVV);
    }
    return dlg;
  }
  function showErr(msg) {
    var e = $('#MtSpinErr');
    e.textContent = msg; e.hidden = !msg;
    $('#MtSpinEmail').setAttribute('aria-invalid', msg && !/box/i.test(msg) ? 'true' : 'false');
  }
  function live(msg) { var l = $('[data-mts-live]'); l.textContent = ''; setTimeout(function () { l.textContent = msg; }, 60); }

  function setStep(s) {
    step = s;
    dlg.setAttribute('data-step', s);
    // both steps share one grid cell (the taller one sets the height): switching never moves the layout (CLS 0)
    var f = $('.mts__step--form'), r = $('.mts__step--result');
    f.classList.toggle('is-off', s === 'result'); f.setAttribute('aria-hidden', s === 'result' ? 'true' : 'false');
    r.classList.toggle('is-off', s !== 'result'); r.setAttribute('aria-hidden', s !== 'result' ? 'true' : 'false');
    r.classList.toggle('is-on', s === 'result');
    var btn = $('[data-mts-spin]');
    btn.disabled = s === 'spinning';
    if (s === 'spinning') $('[data-mts-label]').textContent = T.spinning || 'Spinning\u2026';
  }
  function openDialog(mode) {
    build();
    if (dlg.open) return;
    prevFocus = document.activeElement;
    if (mode === 'result') renderResult(false);
    else if (mode === 'resume') setStep('spinning');
    else setStep('form');
    try { dlg.showModal(); } catch (e) { return; }
    openedAt = Date.now();
    root.classList.add('mts-lock');
    hold(true);
    removePill();
    var h = $('#MtsTitle');
    try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
    if (mode === 'resume') requestAnimationFrame(function () { requestAnimationFrame(function () { animateTo(S.p, true); }); });
    track('spin_open');
  }
  function onClose() {
    if (ignoreClose) { ignoreClose = false; if (dlg.open) return; } // modal -> plain switch (hCaptcha puzzle)
    dlg.classList.remove('is-plain');
    clearTimeout(spinTimer);
    root.classList.remove('mts-lock');
    dlg.classList.remove('is-typing');
    if (step === 'form') {
      if (!closingByDrawer) {
        set(K.dis, Date.now());
        autoEligible = false;
        track('spin_close');
      }
    } else if (step === 'spinning') {
      finish(true);
    }
    var byDrawer = closingByDrawer;
    closingByDrawer = false;
    if (byDrawer) { wasBlocked = true; return; }
    hold(false);
    if (prevFocus && prevFocus.focus && document.contains(prevFocus)) { try { prevFocus.focus({ preventScroll: true }); } catch (e) {} }
    setTimeout(renderPill, 400);
  }

  // ---------- draw ----------
  function rnd() {
    try { var a = new Uint32Array(1); window.crypto.getRandomValues(a); return a[0] / 4294967296; } catch (e) { return Math.random(); }
  }
  function draw() {
    var ps = C.prizes.filter(function (x) { return +x.w > 0; });
    if (!ps.length) ps = [{ p: 5, w: 30 }, { p: 10, w: 40 }, { p: 15, w: 25 }, { p: 20, w: 5 }].map(function (d) { var pz = prizeFor(d.p); return { p: d.p, w: d.w, c: pz ? pz.c : 'SPIN' + d.p }; });
    var tot = ps.reduce(function (a, x) { return a + (+x.w); }, 0), r = rnd() * tot;
    for (var i = 0; i < ps.length; i++) { r -= +ps[i].w; if (r < 0) return ps[i]; }
    return ps[ps.length - 1];
  }
  if (PREVIEW) window.mtSpinTest = { draw: draw, cfg: C };

  // ---------- spin ----------
  var EMAIL_RE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[a-z]{2,}$/i;
  function onSpin() {
    if (step !== 'form') return;
    // already spun in another tab: show that prize, never a second draw
    var prev = validSpin(get(K.spin));
    if (prev) { S = prev; S.r = 1; autoEligible = false; renderResult(false); return; }
    var inp = $('#MtSpinEmail'), email = inp.value.trim();
    if (!EMAIL_RE.test(email)) { showErr(T.errEmail || 'Enter a valid email to spin.'); inp.focus(); return; }
    var cb = $('[data-mts-consent]');
    if (cb && !cb.checked) { showErr(T.errConsent || 'Tick the box so we can send your code.'); cb.focus(); return; }
    showErr('');
    var pz = draw();
    S = { v: 1, p: pz.p, c: pz.c, t: Date.now(), s: 'pending', a: 0, r: 0 };
    set(K.spin, S);
    autoEligible = false;
    try { inp.blur(); } catch (e) {}
    dlg.classList.remove('is-typing');
    setStep('spinning');
    live(T.spinning || 'Spinning\u2026');
    track('spin_submit');
    post(pz.p);
    waitThenSpin(pz.p);
  }
  function animateTo(p, short) {
    var idx = [];
    SLICES.forEach(function (v, i) { if (v === p) idx.push(i); });
    var k = idx[Math.floor(rnd() * idx.length)];
    var jitter = (rnd() * 32) - 16;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var target = ((360 - 45 * k) % 360 + 360) % 360;
    var base = rot - (rot % 360);
    var turns = reduce ? 0 : (short ? 2 : 6);
    var fin = base + turns * 360 + target + jitter;
    if (!reduce && fin < rot + (turns - 1) * 360) fin += 360;
    rot = fin;
    var w = $('.mts__wheel');
    var dur = reduce ? 10 : (short ? 1800 : 5200);
    w.dataset.win = String(k);
    w.style.transition = 'transform ' + dur + 'ms cubic-bezier(.12,.67,.1,1)';
    // force the start frame, then rotate (compositor-only)
    void w.offsetWidth;
    w.style.transform = 'rotate(' + fin + 'deg)';
    clearTimeout(spinTimer);
    spinTimer = setTimeout(function () { finish(false); }, dur + 120);
  }
  function finish(silent) {
    if (step === 'result') return;
    clearTimeout(spinTimer);
    if (!dlg) { step = 'result'; return; }
    renderResult(!silent);
  }
  function renderResult(fx) {
    if (!S) return;
    setStep('result');
    var w = $('.mts__wheel');
    if (!w.dataset.win) {
      // came back (reload / challenge): park the wheel on the recorded prize
      var i0 = SLICES.indexOf(S.p);
      rot = ((360 - 45 * i0) % 360 + 360) % 360;
      w.style.transition = 'none';
      w.style.transform = 'rotate(' + rot + 'deg)';
      w.dataset.win = String(i0);
    }
    var win = +w.dataset.win;
    if (!S.r) { S.r = 1; var s2 = get(K.spin); if (s2) { s2.r = 1; set(K.spin, s2); } else set(K.spin, S); }
    [].forEach.call(dlg.querySelectorAll('.mts__slice'), function (g) { g.classList.toggle('is-win', +g.getAttribute('data-i') === win); });
    dlg.classList.add('has-win');
    var expired = isExpired(S);
    $('[data-mts-won-eyebrow]').textContent = S.p >= 20 ? (T.jackpot || 'JACKPOT') : (T.won || 'YOU WON');
    $('[data-mts-won]').textContent = S.p + '% OFF';
    $('[data-mts-code]').textContent = S.c;
    var fine = $('[data-mts-fine]');
    fine.textContent = expired ? (T.expired || 'This code has expired.') : fill(T.fine, S);
    dlg.classList.toggle('is-expired', expired);
    if (S.s === 'offline') {
      var sub = $('[data-mts-won-sub]');
      sub.textContent = fill(T.offline, S);
    }
    var ap = $('[data-mts-apply]');
    ap.setAttribute('href', applyUrl());
    live('You won ' + S.p + '% off. Your code is ' + S.c + '.');
    if (fx) {
      try { if (navigator.vibrate && (!navigator.userActivation || navigator.userActivation.hasBeenActive)) navigator.vibrate(25); } catch (e) {}
      dlg.classList.remove('is-bump'); void dlg.offsetWidth; dlg.classList.add('is-bump');
      if (S.p >= 20) confetti();
      track('spin_win_' + S.p);
    }
    var h = $('#MtsTitle');
    if (fx) { try { $('[data-mts-copy]').focus({ preventScroll: true }); } catch (e) {} } else { try { h.focus({ preventScroll: true }); } catch (e) {} }
  }
  function confetti() {
    var box = $('.mts__confetti');
    if (!box || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    box.innerHTML = '';
    var cols = ['#C8102E', '#0F5C42', '#FFFFFF', '#C8102E', '#0F5C42'];
    for (var i = 0; i < 28; i++) {
      var s = document.createElement('i');
      s.style.setProperty('--x', Math.round((rnd() - 0.5) * 520) + 'px');
      s.style.setProperty('--y', Math.round(-120 - rnd() * 260) + 'px');
      s.style.setProperty('--r', Math.round(rnd() * 720 - 360) + 'deg');
      s.style.setProperty('--d', Math.round(rnd() * 160) + 'ms');
      s.style.background = cols[i % cols.length];
      box.appendChild(s);
    }
    setTimeout(function () { box.innerHTML = ''; }, 1700);
  }

  // ---------- form post ----------
  // Shopify protects customer forms with invisible hCaptcha (script#captcha-bootstrap): on the first focus it binds
  // the form, wraps form.submit() and adds an h-captcha-response token before calling the ORIGINAL form.submit().
  // Our form.submit is replaced (in build) by sendFetch(), so the wrapped call ends in a fetch (no reload) that
  // carries the token. No captcha on the store -> form.submit() is sendFetch() straight away.
  var postTimer = 0, chWatch = 0;
  function post(p) {
    var form = $('form');
    form.querySelector('[name="contact[tags]"]').value = 'newsletter,spin-wheel,spin-' + p;
    if (FAKE_CH) { setTimeout(function () { challenge(form); }, 900); return; }
    if (DRY) { S.s = 'ok'; set(K.spin, S); return; }
    var hasCaptcha = !!document.getElementById('captcha-bootstrap');
    var bound = function () { return form.hasAttribute('data-hcaptcha-bound'); };
    var t0 = Date.now();
    (function go() {
      if (!hasCaptcha || bound()) { try { form.submit(); } catch (e) { sendFetch(form); } watchCaptcha(); return; }
      if (Date.now() - t0 > 8000) { sendFetch(form); return; } // provider never bound: try without a token
      setTimeout(go, 200);
    })();
    // no answer in 90 s (captcha closed, network): keep the code, mark offline
    clearTimeout(postTimer);
    postTimer = setTimeout(function () { S = get(K.spin) || S; if (S.s === 'pending') { S.s = 'offline'; set(K.spin, S); } }, 90000);
  }
  // The wheel turns once the captcha let the email through (usually < 1 s, invisible), so an hCaptcha puzzle
  // never covers the animation; if the captcha is slow it turns after 2.5 s anyway (puzzle -> waits for it).
  var spinStarted = false;
  function startSpin(p) { if (spinStarted || step !== 'spinning') return; spinStarted = true; animateTo(p, false); }
  function puzzleOn() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var f = frames[i];
      if (/frame=challenge/.test(f.src) && vis(f) && f.getBoundingClientRect().height > 100) return true;
    }
    return false;
  }
  function waitThenSpin(p) {
    spinStarted = false;
    if (DRY || FAKE_CH || !document.getElementById('captcha-bootstrap')) { startSpin(p); return; }
    var t0 = Date.now();
    (function w() {
      if (spinStarted || !dlg || !dlg.open || step !== 'spinning') return;
      if (puzzleOn()) { demodal(); t0 = Date.now() - 2000; setTimeout(w, 250); return; }
      if (Date.now() - t0 > 2500) { startSpin(p); return; }
      setTimeout(w, 150);
    })();
  }
  function sendFetch(form) {
    if (S) startSpin(S.p);
    var ctrl = window.AbortController ? new AbortController() : null, done = false;
    fetch('/contact', { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow', signal: ctrl ? ctrl.signal : undefined })
      .then(function (res) {
        done = true;
        var u = res.url || '';
        try { if (ctrl) ctrl.abort(); } catch (e) {} // only the final URL matters, skip the HTML
        if (/\/challenge/.test(u)) { challenge(form); return; }
        S = get(K.spin) || S;
        S.s = res.ok && /customer_posted=true/.test(u) ? 'ok' : 'offline';
        set(K.spin, S);
        clearTimeout(postTimer);
        track(S.s === 'ok' ? 'spin_subscribed' : 'spin_post_failed');
      })
      .catch(function () {
        if (done) return;
        S = get(K.spin) || S;
        S.s = 'offline'; set(K.spin, S);
      });
  }
  function watchCaptcha() {
    // an hCaptcha puzzle opens under the modal's top layer: turn the wheel into a plain (non-modal) dialog so it can be solved
    clearInterval(chWatch);
    var t0 = Date.now();
    chWatch = setInterval(function () {
      if (!dlg || !dlg.open || (S && S.s !== 'pending') || Date.now() - t0 > 90000) { clearInterval(chWatch); return; }
      if (puzzleOn()) { demodal(); clearInterval(chWatch); }
    }, 300);
  }
  var ignoreClose = false;
  function demodal() {
    if (!dlg || !dlg.open) return;
    try { if (!dlg.matches(':modal')) return; } catch (e) {}
    ignoreClose = true;
    dlg.close();
    dlg.show();
    dlg.classList.add('is-plain');
    track('spin_captcha_puzzle');
  }
  function challenge(form) {
    // Shopify's anti-bot page: the visitor solves it on Shopify's page and comes back with ?customer_posted=true;
    // the prize stays recorded (s = pending) and is revealed on return.
    S = get(K.spin) || S; S.s = 'pending'; set(K.spin, S);
    track('spin_challenge');
    if (FAKE_CH) { location.href = location.pathname + '?customer_posted=true'; return; }
    try { HTMLFormElement.prototype.submit.call(form); } catch (e) {}
  }

  // ---------- copy / apply ----------
  function onCopy() {
    var b = $('[data-mts-copy]'), code = S && S.c;
    if (!code) return;
    var ok = function () { b.textContent = T.copied || 'Copied'; b.classList.add('is-done'); setTimeout(function () { b.textContent = T.copy || 'Copy'; b.classList.remove('is-done'); }, 2200); track('spin_copy'); };
    var fb = function () {
      var i = document.createElement('input'); i.value = code; i.setAttribute('readonly', ''); i.style.cssText = 'position:fixed;opacity:0;top:0;left:0';
      dlg.appendChild(i); i.select(); try { document.execCommand('copy'); } catch (e) {} dlg.removeChild(i); ok();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, fb); else fb();
  }
  function cleanPath() {
    var p = new URLSearchParams(location.search);
    ['mt_spin', 'mt_spin_age', 'mt_spin_dry', 'mt_spin_challenge', 'customer_posted', 'discount'].forEach(function (k) { p.delete(k); });
    var s = p.toString();
    return location.pathname + (s ? '?' + s : '');
  }
  function applyUrl() { return '/discount/' + encodeURIComponent(S.c) + '?redirect=' + encodeURIComponent(cleanPath()); }
  function onApply(e) {
    if (!S) return;
    e.preventDefault();
    patchSpin('a', 1);
    sset('mt_spin_applied', '1');
    track('spin_apply');
    location.href = applyUrl();
  }

  // ---------- pill + toast ----------
  var pill = null, pillMode = '';
  function removePill() { if (pill) { pill.remove(); pill = null; } }
  function pillWanted() {
    if (excludedPage && /^\/cart/.test(location.pathname)) return '';
    if (dlg && dlg.open) return '';
    if (S) {
      if (isExpired(S)) return '';
      if (S.x && Date.now() < S.x) return '';
      return 'code';
    }
    if (C.teaser && !autoEligible && get(K.dis) && !get(K.sub) && !C.known && !excludedPage) {
      var hid = +get('mt_spin_px') || 0;
      if (Date.now() < hid) return '';
      return 'pre';
    }
    return '';
  }
  function renderPill() {
    var want = pillWanted();
    if (!want) { removePill(); return; }
    if (pill && pillMode === want) { pillGuard(); return; }
    loadCss(function () {
      removePill();
      pillMode = want;
      pill = document.createElement('div');
      pill.className = 'mts-pill' + (want === 'code' ? ' mts-pill--code' : '');
      var main = document.createElement('button');
      main.type = 'button'; main.className = 'mts-pill__main';
      var label;
      if (want === 'code') {
        var dl = daysLeft(S);
        label = S.a ? (S.c + ' \u00b7 ' + S.p + '% off single items') : (S.c + ' \u00b7 ' + S.p + '% off \u00b7 ' + (dl <= 1 ? 'Last day' : dl + ' days left'));
      } else {
        label = T.pillPre || 'Win up to 20% off';
      }
      main.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M3 11h18v10H3zM2 7h20v4H2zM12 7v14M12 7c-2-4-6-4-6-1.5S9 7 12 7zm0 0c2-4 6-4 6-1.5S15 7 12 7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg><span></span>';
      main.querySelector('span').textContent = label;
      main.setAttribute('aria-label', want === 'code' ? ('Your code ' + label) : label);
      main.addEventListener('click', function () {
        track('spin_pill');
        if (want === 'code') openDialog('result'); else openDialog('form');
      });
      var x = document.createElement('button');
      x.type = 'button'; x.className = 'mts-pill__x'; x.setAttribute('aria-label', 'Hide');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>';
      x.addEventListener('click', function () {
        if (want === 'code') patchSpin('x', Date.now() + DAY); else set('mt_spin_px', Date.now() + DAY);
        removePill();
      });
      pill.appendChild(main); pill.appendChild(x);
      document.body.appendChild(pill);
      pillGuard();
    });
  }
  var lastOff = -1;
  function pillGuard() {
    // stay above the sticky add-to-cart bar (transform only: no layout shift).
    // --mt-sticky-off on <html> also lifts Shopify's hCaptcha badge, which stays on the page after the form is touched
    var off = 0, st = document.querySelector('sticky-atc');
    if (st && !st.classList.contains('mt-sticky-off')) {
      var r = st.getBoundingClientRect(), cs = getComputedStyle(st);
      if (cs.display !== 'none' && cs.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight && r.bottom >= window.innerHeight - 4) off = Math.round(window.innerHeight - r.top);
    }
    if (off !== lastOff) { lastOff = off; root.style.setProperty('--mt-sticky-off', off + 'px'); }
    if (!pill) return;
    var hide = drawerOpen() || bannerOn() || ccdOn() || otherModal() || /(^|\s)overflow-hidden/.test(document.body.className);
    pill.classList.toggle('is-hidden', hide);
    pill.style.setProperty('--mts-off', off + 'px');
  }
  function toast(msg) {
    loadCss(function () {
      var t = document.createElement('div');
      t.className = 'mts-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
      document.body.appendChild(t);
      setTimeout(function () { t.classList.add('is-out'); setTimeout(function () { t.remove(); }, 400); }, 4200);
    });
  }

  // ---------- main loop ----------
  var opened = false, holdSafety = 0, wasBlocked = false;
  function loop() {
    var acc = tick();
    if (dlg && dlg.open) {
      if (drawerOpen() || (/(^|\s)overflow-hidden/.test(document.body.className))) {
        closingByDrawer = step === 'form';
        if (closingByDrawer) { autoEligible = true; opened = false; wasBlocked = true; freeSince = 0; }
        dlg.close();
      }
      return;
    }
    pillGuard();
    if (!autoEligible || opened) return;
    if (acc >= DELAY - 5 || NOW) loadCss();
    if (acc < DELAY && !NOW) return;
    var why = blockReason();
    if (why) {
      freeSince = 0;
      wasBlocked = true;
      if (!holdSafety) holdSafety = Date.now();
      // never keep the cookie notice hidden for more than 45 s past the due time
      if (Date.now() - holdSafety > 45000 && why !== 'cookie-notice') root.classList.remove('mt-spin-hold-ccd');
      return;
    }
    if (!freeSince) freeSince = Date.now();
    var needFree = wasBlocked ? 1500 : 0;
    if (Date.now() - freeSince < needFree || cssState !== 2) { loadCss(); return; }
    opened = true;
    openDialog('form');
  }

  // ---------- boot ----------
  function boot() {
    if (S) {
      // back from Shopify's challenge page (customer_posted=true) or reloaded before the result showed:
      // reveal the recorded prize (no new draw)
      var back = S.s === 'pending' && posted;
      if (back) { S.s = 'ok'; set(K.spin, S); }
      else if (S.s === 'pending' && S.r) { S.s = 'offline'; set(K.spin, S); } // left mid-post: the code still works
      if ((back || !S.r) && !isExpired(S) && !excludedPage) loadCss(function () { openDialog('resume'); });
      if (sget('mt_spin_applied') === '1') {
        sset('mt_spin_applied', null);
        toast(fill(T.applied || '[code] applied. [pct]% comes off single items at checkout.', S));
      }
    }
    if (NOW && S) loadCss(function () { openDialog('result'); });
    renderPill();
    loop();
    setInterval(loop, 1000);
    var mo = new MutationObserver(function () { if (dlg && dlg.open) { if (drawerOpen()) loop(); } else pillGuard(); });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var cd = document.querySelector('cart-drawer');
    if (cd) mo.observe(cd, { attributes: true, attributeFilter: ['class'] });
    // spin in another tab: show that prize here (read-only: this tab never writes back what it just read)
    window.addEventListener('storage', function (e) {
      if (e.key !== K.spin) return;
      var s = validSpin(get(K.spin));
      if (!s) return;
      if (S) { if (S.t === s.t) { var r = S.r; S = s; if (r) S.r = 1; } return; }
      S = s; S.r = 1; autoEligible = false;
      if (dlg && dlg.open) { if (step === 'form') renderResult(false); }
      else { hold(false); renderPill(); }
    });
    window.addEventListener('pagehide', tick);
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') lastTick = Date.now(); else tick(); });
    window.addEventListener('scroll', function () { requestAnimationFrame(pillGuard); }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
